var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.app.platformCode === 'fabric')?_c('p',[_c('FabricLogo',{attrs:{"color":_vm.color}})],1):_c('p',[_c('RevCascadeLogo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }